export default "__VITE_ASSET__M1J8cFPT__"